import { __extends } from "tslib";
import classNames from 'classnames';
import React, { Component, } from 'react';
import s from './Input.scss';
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        _this.state = {
            state: '',
            showIndicator: false,
        };
        _this.handleClick = function (event) {
            if (!_this.props.disabled) {
                _this.focus();
                if (_this.props.onClick) {
                    _this.props.onClick(event);
                }
            }
        };
        _this.handleInputBlur = function (event) {
            _this.setState({ state: '', showIndicator: false });
            if (_this.props.onBlur) {
                _this.props.onBlur(event);
            }
        };
        _this.handleInputFocus = function (event) {
            _this.setState({ state: s.focus, showIndicator: true });
            if (_this.props.onFocus) {
                _this.props.onFocus(event);
            }
        };
        _this.handleInputChange = function (event) {
            if (_this.props.onChange) {
                _this.props.onChange(event);
            }
        };
        return _this;
    }
    Input.prototype.focus = function () {
        if (this.inputRef.current) {
            this.inputRef.current.focus();
        }
    };
    Input.prototype.render = function () {
        var _a, _b;
        var _c = this.props, text = _c.text, placeholder = _c.placeholder, prefix = _c.prefix, _d = _c.size, size = _d === void 0 ? 'medium' : _d, _e = _c.limit, limit = _e === void 0 ? 0 : _e, showErrors = _c.showErrors, errorMessage = _c.errorMessage, id = _c.id, name = _c.name, dataAid = _c.dataAid, autoFocus = _c.autoFocus, _f = _c.disabled, disabled = _f === void 0 ? false : _f, className = _c.className, inputClassName = _c.inputClassName, hideLimitIndicator = _c.hideLimitIndicator;
        var _g = this.state, state = _g.state, showIndicator = _g.showIndicator;
        var limitText = limit - text.length || '';
        return (React.createElement("div", { className: classNames(s.outerContainer, state, s[size], className, (_a = {},
                _a[s.disabled] = disabled,
                _a[s.hasError] = showErrors,
                _a)), onClick: this.handleClick },
            React.createElement("div", { className: classNames(s.container, state, s[size]) },
                prefix ? React.createElement("span", { className: s.prefix }, prefix) : null,
                React.createElement("input", { className: inputClassName, autoFocus: autoFocus, type: "text", autoComplete: "off", "data-aid": dataAid, disabled: disabled, ref: this.inputRef, id: id, name: name, placeholder: placeholder || '', maxLength: limit || undefined, onBlur: this.handleInputBlur, onFocus: this.handleInputFocus, onChange: this.handleInputChange, value: text }),
                hideLimitIndicator ? null : (React.createElement("div", { className: classNames(s.suffix, (_b = {},
                        _b[s.visible] = showIndicator && limit,
                        _b)) }, limitText))),
            showErrors && (React.createElement("span", { className: s.errorMessage, "data-hook": "input-error-message" }, errorMessage))));
    };
    Input.defaultProps = {
        size: 'medium',
    };
    return Input;
}(Component));
export default Input;
//# sourceMappingURL=Input.js.map